export const E_PURSE_PRD_FAMILY = 'Epurse';
export const CAPP_PRD_FAMILY = 'CAPP';
export const MDP_PRD_FAMILY = 'MDP';
export const SINGLE_FARE_CRD_CART_ITEM_NAME = 'SINGLE FARECARD';
export const NEWMEDIA_VISIBLE_ID = 'NEWMEDIA';
export const PRICE_BUTTONS = ['10.00', '25.00', '50.00'];
export const MAX_NO_OF_TRANSIT_PASSES = 6;
export const SINGLE_FARE_CRD_CART_FAMILY_NAME = 'Fare Media';
export const NO_OF_BASIC_PERIOD = 12;
